export default "__VITE_ASSET__AEB20HGt__"